<template>
  <div
    class="hidden lg:flex mt-24 mb-12 items-center px-box-2 container flex-row gap-2 justify-evenly"
  >
    <picture>
      <source srcset="../images/full-app-screen.png" media="(min-width: 1026px)" />
      <img
        class="h-168 drop-shadow-4"
        src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'/%3E"
        alt=""
      />
    </picture>
    <div class="flex flex-col items-center max-w-1/2 justify-center">
      <p class="font-bold text-32 text-left">
        {{ $t('app_prompt.title') }}
      </p>
      <div class="w-full items-center mt-6 text-18 font-medium grid grid-cols-2 gap-x-14 gap-y-8">
        <SellingPoints />
      </div>
      <div class="flex flex-wrap w-full gap-x-10 gap-y-6 justify-normal mt-18">
        <StoreLinks :link @track-click="trackClick" />
        <img src="../images/app-qr.png" class="h-28" alt="" loading="lazy" />
        <ScanMe class="-mt-8" />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import SellingPoints from '../selling-points.vue'
import StoreLinks from '../store-links.vue'
import ScanMe from '../scan-me.vue'
import { AppPromptClick } from '@core/analytics/core-events/app'

const props = defineProps<{
  promptType: 'HeroSearchForm_Country' | 'HeroSearchForm_Home' | 'HeroSearchForm_IMT'
}>()

const { $track } = useNuxtApp()

const link = useAppLink(`prompt_${props.promptType}`)

async function trackClick() {
  await $track(AppPromptClick(props.promptType))
}
</script>
